import React from 'react';

import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { StoreContext } from 'redux-react-hook';

import App from './App';
import LoadingScreen from './components/Atoms/LoadingScreen/LoadingScreen';
import { AlertProvider } from './context/AlertContext';
import { SocketProvider } from './context/WebSocketContext';
import { makeStore } from './redux/reducers';
import * as serviceWorker from './serviceWorker';

import './App.scss';

const { persistor, store } = makeStore();

ReactDOM.render(
  <StoreContext.Provider value={store}>
    <PersistGate loading={<LoadingScreen />} persistor={persistor}>
      <Provider store={store}>
        <AlertProvider>
          <SocketProvider>
            <App />
          </SocketProvider>
        </AlertProvider>
      </Provider>
    </PersistGate>
  </StoreContext.Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
